import { Controller } from "stimulus";
import { reloadBootstrapTooltip } from "../util/tooltip";

export default class extends Controller {
  static targets = ["navigationCurrency", "navigationOverallStats"];

  connect() {
    setTimeout(()=> {
      this.scrollToTop();
      this.initBootstrapTooltip();
      this.initLazyImage();
      this.initLoadCSS();
      this.asyncRenderNavigationCurrency();
      this.asyncRenderNavigationOverallStats().then(()=>{
          reloadBootstrapTooltip()
        }
      )
      // })
    },0);
  }

  asyncRenderNavigationCurrency() {
    fetch(this.navigationCurrencyTarget.dataset.url)
      .then(response => {
        return response.text();
      }).then( html => {
        this.navigationCurrencyTarget.innerHTML = html;
        document.dispatchEvent(new CustomEvent('currency-selector-loaded'));
      });
  }

  asyncRenderNavigationOverallStats() {
    return fetch(this.navigationOverallStatsTarget.dataset.url)
      .then(response => {
        return response.text();
      }).then(html => {
        this.navigationOverallStatsTargets.forEach(t => {
          t.innerHTML = html;
        });
      });
  }

  scrollToTop() {
    document.getElementById('toTop').addEventListener("click", function(){
      window.scrollTo({ top: 0, behavior: "smooth" });
      return false;
    });
  }

  gtagEventTrackLink(event) {
    const element = event.currentTarget
    const eventCategory = element.dataset.eventCategory
    const source = element.dataset.source
    const destination = element.dataset.destination
    // GA3 Universal
    // gtag('event', 'click', {
    //   'event_category': eventCategory,
    //   'event_label': source,
    //   'source': source,
    //   'destination': destination
    // });

    // GA4
    gtag('event', eventCategory, {
      'source': source,
      'destination': destination
    });
  }

  initBootstrapTooltip() {
    $(function() {
      const resetTooltip = () => {
        $('[data-toggle="tooltip"]').tooltip();
        $('[data-toggle="popover"]').popover();
        $('[data-toggle="popover"]').not(".btn-promotion").popover(
          {
            trigger: "manual",
            html: true,
            animation:false
          }
        ).on("mouseenter", function () {
          var _this = this;
          $(this).popover("show");
            $(".popover").on("mouseleave", function () {
              setTimeout(function () {
                $(_this).popover('hide');
              }, 100);
          });
        }).on("mouseleave", function () {
          var _this = this;
          setTimeout(function () {
            if (!$(".popover:hover").length) {
              $(_this).popover("hide");
            }
          }, 300);
        });
      };

      window.addEventListener("coingecko-reset-tooltip", resetTooltip);
      setTimeout(resetTooltip, 300);
    });
  }

  initLazyImage() {
    // Lazy load image
    let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
    let active = false;

    const lazyLoad = function() {
      if (active === false) {
        active = true;

        setTimeout(function() {
          lazyImages.forEach(function(lazyImage) {
            if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
              lazyImage.src = lazyImage.dataset.src;
              lazyImage.srcset = lazyImage.dataset.srcset;
              lazyImage.classList.remove("lazy");

              lazyImages = lazyImages.filter(function(image) {
                return image !== lazyImage;
              });

              if (lazyImages.length === 0) {
                document.removeEventListener("scroll", lazyLoad);
                window.removeEventListener("resize", lazyLoad);
                window.removeEventListener("orientationchange", lazyLoad);
                [...document.getElementsByClassName("table")].forEach(node => node.removeEventListener('afterSort', lazyLoad));
              }
            }
          });

          active = false;
        }, 200);
      }
    };

    lazyLoad();
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad);
    [...document.getElementsByClassName("table")].forEach(node => node.addEventListener('afterSort', lazyLoad));
  }

  initLoadCSS() {
    /*! loadCSS. [c]2017 Filament Group, Inc. MIT License */
    /* This file is meant as a standalone workflow for
    - testing support for link[rel=preload]
    - enabling async CSS loading in browsers that do not support rel=preload
    - applying rel preload css once loaded, whether supported or not.
    */
    (function( w ){
      "use strict";
      // rel=preload support test
      if( !w.loadCSS ){
        w.loadCSS = function(){};
      }
      // define on the loadCSS obj
      var rp = loadCSS.relpreload = {};
      // rel=preload feature support test
      // runs once and returns a function for compat purposes
      rp.support = (function(){
        var ret;
        try {
          ret = w.document.createElement( "link" ).relList.supports( "preload" );
        } catch (e) {
          ret = false;
        }
        return function(){
          return ret;
        };
      })();

      // if preload isn't supported, get an asynchronous load by using a non-matching media attribute
      // then change that media back to its intended value on load
      rp.bindMediaToggle = function( link ){
        // remember existing media attr for ultimate state, or default to 'all'
        var finalMedia = link.media || "all";

        function enableStylesheet(){
          // unbind listeners
          if( link.addEventListener ){
            link.removeEventListener( "load", enableStylesheet );
          } else if( link.attachEvent ){
            link.detachEvent( "onload", enableStylesheet );
          }
          link.setAttribute( "onload", null );
          link.media = finalMedia;
        }

        // bind load handlers to enable media
        if( link.addEventListener ){
          link.addEventListener( "load", enableStylesheet );
        } else if( link.attachEvent ){
          link.attachEvent( "onload", enableStylesheet );
        }

        // Set rel and non-applicable media type to start an async request
        // note: timeout allows this to happen async to let rendering continue in IE
        setTimeout(function(){
          link.rel = "stylesheet";
          link.media = "only x";
        });
        // also enable media after 3 seconds,
        // which will catch very old browsers (android 2.x, old firefox) that don't support onload on link
        setTimeout( enableStylesheet, 3000 );
      };

      // loop through link elements in DOM
      rp.poly = function(){
        // double check this to prevent external calls from running
        if( rp.support() ){
          return;
        }
        var links = w.document.getElementsByTagName( "link" );
        for( var i = 0; i < links.length; i++ ){
          var link = links[ i ];
          // qualify links to those with rel=preload and as=style attrs
          if( link.rel === "preload" && link.getAttribute( "as" ) === "style" && !link.getAttribute( "data-loadcss" ) ){
            // prevent rerunning on link
            link.setAttribute( "data-loadcss", true );
            // bind listeners to toggle media back
            rp.bindMediaToggle( link );
          }
        }
      };

      // if unsupported, run the polyfill
      if( !rp.support() ){
        // run once at least
        rp.poly();

        // rerun poly on an interval until onload
        var run = w.setInterval( rp.poly, 500 );
        if( w.addEventListener ){
          w.addEventListener( "load", function(){
            rp.poly();
            w.clearInterval( run );
          } );
        } else if( w.attachEvent ){
          w.attachEvent( "onload", function(){
            rp.poly();
            w.clearInterval( run );
          } );
        }
      }


      // commonjs
      if( typeof exports !== "undefined" ){
        exports.loadCSS = loadCSS;
      }
      else {
        w.loadCSS = loadCSS;
      }
    }( typeof global !== "undefined" ? global : this ) );
  }

  navigateToUrl(e) {
    let url = e.target.dataset.url
    if (url) {
      window.location = url;
    }
  }
}
